/**
 * Allowlist of panel names that can appear in a workflow step's
 * `workspaceLayout.panels[].component` field (parsed per-step in
 * `mapEntryToLibraWorkflow`).
 *
 * This module deliberately has NO component imports -- the Zod schema
 * (workspaceLayoutTypes.ts) consumes these names, and the runtime registry
 * (workspacePanels/index.ts) maps them to actual components. Keeping the
 * names separate from the components avoids pulling the FFS asset viz UI
 * into workflow-parsing code paths.
 */
export const WORKSPACE_PANEL_NAMES = [
  'FfsAssetVizPanel',
  'ActiveStepContent',
  'DocumentNavigationPanel',
  'DocumentViewerPanel',
] as const

export type WorkspacePanelName = (typeof WORKSPACE_PANEL_NAMES)[number]
